import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

const customAxios = axios.create({});

const responseHandler = (response: AxiosResponse): AxiosResponse => {
  const { method, url } = response.config;
  const { status } = response;

  // console.log(`🚀 [API] ${method?.toUpperCase()} ${url} | Response ${status}`);

  if (response.status === 401) {
    window.location.href = `/${response.config.headers.tenant}/login`;
  }

  return response;
};

function requestHandler(config: AxiosRequestConfig): AxiosRequestConfig {
  const { method, url } = config;

  // console.log(`🚀 [API] ${method?.toUpperCase()} ${url} | Request`);

  return config;
}

const errorHandler = (error: AxiosError): Promise<AxiosError> => {
  console.log(
    "%c errorHandler: %o",
    "background-color: red; color: white;",
    error,
    error.response?.config.headers.tenant,
    error.config
  );
  // console.error(`[response error] [${JSON.stringify(error)}]`);
  if (axios.isAxiosError(error)) {
    const { message } = error;
    const { method, url } = error.config as AxiosRequestConfig;
    const { statusText, status } = (error?.response as AxiosResponse) ?? {};
    const { tenant } = error.config.headers;

    console.error(
      `🚨 [API] ${method?.toUpperCase()} ${url} | Error ${status} ${message}`
    );

    switch (status) {
      case 401: {
        // "Login required"
        break;
      }
      case 403: {
        // "Permission denied"
        break;
      }
      case 404: {
        // "Invalid request"
        break;
      }
      case 500: {
        // "Server error"
        break;
      }
      default: {
        // "Unknown error occurred"
        break;
      }
    }

    if (status === 401) {
      // Delete Token & Go To Login Page if you required.
      sessionStorage.removeItem("token");
    }
  } else {
    console.error(`🚨 [API] | Error ${error}`);
  }

  return Promise.reject(error);
};

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

export default customAxios;
